module.exports = __webpack_public_path__ + "img/user.585fdb88.png";